import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { SidebarRoute } from "../../utils/routes/types";

interface IProps {
  children: React.JSX.Element;
  routes?: SidebarRoute[] | undefined;
}

const Layout = ({ children, routes }: IProps) => {
  return (
    <>
      <Header />
      <Sidebar routes={routes} />
      <div className="main-content app-content">
        <div className="container-fluid">{children}</div>
      </div>
      <Footer />
    </>
  );
};

export default Layout;
